import React, { useState } from 'react';
import Button from './Button';
import Image from '../AppImage';

const CountryFilter = ({ onFilterChange, activeFilter = 'all' }) => {
  const [selectedFilter, setSelectedFilter] = useState(activeFilter);

  const filterOptions = [
    {
      id: 'all',
      label: 'All Trails',
      count: 24,
      flag: null
    },
    {
      id: 'serbia',
      label: 'Serbia',
      count: 12,
      flag: '/assets/images/flags/serbia.png'
    },
    {
      id: 'montenegro',
      label: 'Montenegro',
      count: 12,
      flag: '/assets/images/flags/montenegro.png'
    }
  ];

  const handleFilterChange = (filterId) => {
    setSelectedFilter(filterId);
    onFilterChange(filterId);
  };

  return (
    <div className="bg-card rounded-lg shadow-card p-6 mb-8">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>
          <h2 className="font-heading font-semibold text-lg text-foreground mb-1">
            Explore Heritage Trails
          </h2>
          <p className="text-muted-foreground text-sm">
            Discover cultural and natural heritage across the Balkans
          </p>
        </div>
        
        <div className="flex flex-wrap gap-2">
          {filterOptions?.map((option) => (
            <Button
              key={option?.id}
              variant={selectedFilter === option?.id ? 'default' : 'outline'}
              size="sm"
              onClick={() => handleFilterChange(option?.id)}
              className="flex items-center gap-2 transition-all duration-fast"
            >
              {option?.flag && (
                <div className="w-4 h-3 rounded-sm overflow-hidden flex-shrink-0">
                  <Image
                    src={option?.flag}
                    alt={`${option?.label} flag`}
                    className="w-full h-full object-cover"
                  />
                </div>
              )}
              <span className="font-medium">{option?.label}</span>
              <span className={`text-xs px-1.5 py-0.5 rounded-full ${
                selectedFilter === option?.id 
                  ? 'bg-primary-foreground/20 text-primary-foreground' 
                  : 'bg-muted text-muted-foreground'
              }`}>
                {option?.count}
              </span>
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CountryFilter;